var map = {
	"./burger.svg": 231,
	"./check.svg": 232,
	"./cross.svg": 233,
	"./logo.svg": 234,
	"./mail.svg": 235,
	"./map-marker.svg": 236,
	"./offer-address.svg": 237,
	"./offer-audiences.svg": 238,
	"./offer-type.svg": 239,
	"./phone.svg": 240
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;



//////////////////
// WEBPACK FOOTER
// ./svgs \.svg$
// module id = 112
// module chunks = 1